import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table'
import Moment from 'react-moment';

export default function Tournaments(props) {

    const [tournaments, setTournaments] = useState([])

    useEffect(() => {

        fetch('https://playattitude.fr/admin/tournaments/all', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                console.log('tournois', res)
                setTournaments(res)

            })
    }, [])

    return (
        <div>
            <h2>Tournament</h2>
            <MaterialTable
                columns={[
                    {
                        title: 'Logo',
                        field: 'id',
                        render: rowData => (
                            <img
                                style={{ height: 80, borderRadius: '0%' }}
                                src={'https://playattitude.fr/img/' + rowData.id + ".png"}
                            />
                        ),
                    },
                    { title: 'Nom', field: 'name' },
                    { title: 'Ville', field: 'city' },
                    { title: 'Code Postal', field: 'zipcode' },
                    {
                        title: 'Debut', field: 'start',
                        render: rowData => (
                            <Moment format="DD/MM/YYYY hh:mm">
                                {rowData.start}
                            </Moment>
                        )
                    },
                    {
                        title: 'Fin', field: 'end',
                        render: rowData => (
                            <Moment format="DD/MM/YYYY hh:mm">
                                {rowData.end}
                            </Moment>
                        )
                    },
                    { title: 'Format', field: 'format' },
                    { title: 'Places max', field: 'maxSlot' },
                    { title: 'Inscrit', field: 'countRegistered' },


                ]}
                data={tournaments}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Voir le détail',
                        onClick: (event, rowData) =>  props.history.push("/tournament/" + rowData.id)
                    }
                ]}
                options={{
                    actionsColumnIndex: -1,
                    exportButton: true

                }}
                title="Mes tournois"
            />
        </div>
    );
}